
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import { t } from '@/utils/dicts/dict'
import { dictMap } from '@/utils/dicts/dicts'
import { setPayDeadline } from '@/api/ordercenter'
import dayjs from 'dayjs'

@Component({
  name: 'deadline-dialog'
})

export default class DeadlineDialog extends Vue {
  @PropSync('visible', { type: Boolean, default: !1 })
  private visibleSync!: boolean

  @Prop({ type: String })
  private title!: string

  @Prop({ type: Object })
  private data!: object|any

  private t = t

  private value (item: any, i: any) {
    return dictMap[i] ? dictMap[i](item) : (item || '')
  }

  private dictMap = dictMap

  private form: any = {
    orderNo: '',
    payDeadline: '',
    deadlineSelected: -1
  }

  private rules = {
    payDeadline: [{ required: true, message: '请选择支付截止时间', trigger: 'blur' }]
  }

  private deadlineOptions = [
    {
      value: -1,
      label: '永久'
    },
    {
      value: 0,
      label: '具体时间'
    }
  ]

  private payDeadlineOptions = {
    disabledDate (time) {
      // 8.64e7一天
      return time.getTime() < Date.now() - 8.64e7
    }
  }

  private timeConvert (timeStamp: number) {
    return !timeStamp || timeStamp === -1 ? '' : dayjs(timeStamp).format('YYYY-MM-DD HH:mm')
  }

  private initData () {
    this.form.orderNo = this.data.orderNo
    this.form.payDeadline = this.data.payDeadline !== -1 ? this.data.payDeadline : ''
    this.form.deadlineSelected = this.data.payDeadline !== -1 ? 0 : this.data.payDeadline
    this.$nextTick(() => {
      (this.$refs.form as any).clearValidate()
    })
  }

  private handleSelectedDeadlineChange () {
    (this.$refs.form as any).clearValidate()
  }

  private deadlineChange (v: any) {
    if (v == null) {
      this.form.payDeadline = ''
      return
    }
    this.form.payDeadline = v + 8.64e7 - 1000
  }

  private async setDeadlineTime () {
    this.form.orderNo = this.data.orderNo
    if (this.form.deadlineSelected === -1) {
      this.form.payDeadline = -1
    }
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        const temp = { ...this.form }
        delete temp.deadlineSelected
        await setPayDeadline({
          ...temp
        }).then(async (res: any) => {
          this.form.orderNo = ''
          this.form.payDeadline = ''
          this.form.deadlineSelected = -1
          this.visibleSync = !1
          this.$listeners['call-back'] && this.$emit('call-back')
          this.$message.success(res.message)
        }).catch((err: any) => {
          console.log('err', err)
        })
      }
    })
  }
}
